import { computed, Inject, Injectable, Signal } from '@angular/core';

import { AbstractLanguageService, Language, LANGUAGE_SERVICE_INJECTOR } from '@campaign-portal/components-library';
import { LanguageOption, LanguageProvider } from '@campaign-portal/contracts/language';

@Injectable({ providedIn: 'root' })
export class AlarisLanguageAdapter extends LanguageProvider {
	readonly list: readonly LanguageOption[];

	readonly current: Signal<LanguageOption> = computed(() => this.toOption(this.source.current()));

	constructor(@Inject(LANGUAGE_SERVICE_INJECTOR) private readonly source: AbstractLanguageService) {
		super();
		this.list = this.source.getLanguages().map((l) => this.toOption(l));
	}

	set(id: string): void {
		this.source.set(id);
	}

	private toOption(lang: Language): LanguageOption {
		return { id: lang.id, title: lang.title };
	}
}
